import Swiper from "./swiper-bundle.min"


function notification(message, status, delay = 5000) {
    const main = document.getElementById('notification-area');
    let bg_color = 'bg-secondary'
    switch (status) {
        case "success":
            bg_color = "bg-success";
            break;
        case "error":
            bg_color = 'bg-danger';
            break;
        case "info":
            bg_color = 'bg-info';
            break;
        case "warning":
            bg_color = 'bg-warning';
            break;
    }
    const message_div = document.createElement('div');
    message_div.setAttribute('style', `width: 250px;display:none;`);
    message_div.setAttribute('class', `p-2 border rounded ${bg_color} m-4`);
    message_div.innerHTML = message;
    $(message_div).fadeIn();
    main.append(message_div);
    setTimeout(() => {
        $(message_div).fadeOut();
        setTimeout(() => {
            message_div.remove();
        }, 500)
    }, delay);
}

function closeSessionModal(event) {
    $("#sessionModal").remove();
}

$(document).ready(function () {
    let filterCount = '0';
    const filterCountElement = document.querySelector('.filters #filterCount');
    if (filterCountElement) {
        filterCount = filterCountElement.value;
    }

    let catalogCount = '0';
    const catalogCountElement = document.querySelector('.filters #catalogCount');
    if (catalogCountElement) {
        try {
            catalogCount = JSON.parse(catalogCountElement.value);
        } catch (e) {
            console.error('Error parsing catalogCount:', e);
        }
    }


    $(document).on('click', '.level-toggler span', function (e) {
        e.preventDefault();
        let data_type = $(this).parent().children("a").attr("data-type");
        let data_level = $(this).parent().children("a").attr("data-level");
        let item = $('.level-' + data_level + `[data-type="${data_type}"]`);

        if (e.currentTarget.classList.contains('no-rendered-child')) {
            const data_id = $(this).parent().children("a").attr("data-id");
            $.ajax({
                url: window.location.origin + '/catalog/getChild',
                data: {id: data_id},
                type: 'GET',
                success: function (response) {
                    e.currentTarget.classList.remove('no-rendered-child');
                    const child_block = createChild({
                        categoryData: response.categoryData,
                        data_type: data_type,
                        data_level: data_level
                    });

                    e.currentTarget.parentNode.parentNode.insertBefore(child_block, e.currentTarget.parentNode.nextSibling);
                    // $(".level-toggler span").click(toggler_click);
                },
                error: function (response) {
                    console.log(response);
                }
            });
        }

        item.toggleClass("active");
        $(this).toggleClass("active")
        let el = $(this).parent()
        el.toggleClass("active")


        let type = el.attr("data-type")


        if (window.innerWidth < 750) {
            el.parent().children().each(
                (key, item) => {
                    if (item.getAttribute("data-type") != type) {
                        if (item.classList.contains("hidden")) {
                            item.classList.remove("hidden")
                            document.querySelectorAll(".filters-item .level-toggler.active").forEach(
                                item => {
                                    if (item.getAttribute("data-type") != type) {
                                        item.style.display = "none"
                                    } else {
                                        item.style.display = "flex"
                                    }
                                }
                            )
                        } else {
                            item.classList.add("hidden")
                            document.querySelectorAll(".filters-item .level-toggler.active").forEach(
                                item => {
                                    if (item.getAttribute("data-type") != type) {
                                        item.style.display = "none"
                                    } else {
                                        item.style.display = "flex"
                                    }
                                }
                            )
                        }
                    }
                }
            )

            let last_type = $(".level.active").last().attr("data-type")
            $(`.level-toggler[data-type="${last_type}"]`).css({
                "display": "flex"
            })
        }
    });

    function createChild({categoryData, data_type, data_level}) {
        const child_list = document.createElement('ul');
        child_list.setAttribute('class', 'd-flex flex-column');
        for (const index in categoryData) {
            const item = categoryData[index];
            let arrow = '';
            if (item.has_children) {
                arrow = document.createElement('span');
                arrow.setAttribute('class', 'p-2 no-rendered-child');
                arrow.innerHTML = `<img src="https://partsell.ru/img/arrow-down-black.svg" alt="">
                        <img src="https://partsell.ru/img/cross-x.svg" alt="" class="close">`;
            }

            const child = document.createElement('li');
            child.dataset.type = item.item_slug;
            child.dataset.level = item.level;
            child.setAttribute('class', 'level-toggler');
            child.dataset.id = item.id;
            const child_link = document.createElement('a');
            child_link.href = window.location.origin + '/catalog/' + getFullSlug(item.full_slug);
            child_link.dataset.url = window.location.origin + '/catalog/' + getFullSlug(item.full_slug);
            child_link.dataset.type = item.item_slug;
            child_link.dataset.id = item.id;
            child_link.dataset.level = item.level;
            child_link.setAttribute('class', 'main-text');
            child_link.innerHTML = item.name + (filterCount === "1" ? ` (${catalogCount[item.id]})` : "");
            child_link.dataset.withoutfilter = `${(filterCount === "1" && catalogCount[item.id] === 0) ? 1 : 0}`;
            child_link.setAttribute('onmouseover', "link_filter(event)");
            child.append(child_link);
            child.append(arrow);
            child_list.append(child);
        }

        const child_block = document.createElement('li');
        child_block.dataset.type = data_type;
        child_block.setAttribute('class', `level level-${data_level} active`);
        child_block.append(child_list);
        return child_block;
    }

    function link_filter(e) {
        const filter = collect_filter();
        if (e.target.dataset.withoutfilter == true)
            e.target.setAttribute('href', e.target.dataset.url);
        else
            e.target.setAttribute('href', e.target.dataset.url + filter);
    }

    function collect_filter() {
        let path = '';
        let brands = [], manufacturers = [];
        $('.brands').each(function (index, el) {
            if ($(el).prop('checked') === true) brands.push($(el).data('slug'));
        });
        $('.manufacturers').each(function (index, el) {
            if ($(el).prop('checked') === true) manufacturers.push($(el).data('slug'));
        });
        if (brands.length < 2 && manufacturers.length < 2) {
            if (brands[0]) path += `/br_${brands[0]}`;
            if (manufacturers[0]) path += `/pr_${manufacturers[0]}`;
            return path;
        } else {
            if (brands.length) {
                if (!path.length) {
                    path = '?brand=' + brands.join('|');
                } else {
                    path += '&brand=' + brands.join('|');
                }
            }
            if (manufacturers.length) {
                if (!path.length) {
                    path = '?manufacturer=' + manufacturers.join('|');
                } else {
                    path += '&manufacturer=' + manufacturers.join('|');
                }
            }
            return path;
        }
    }

    function getFullSlug(full_slug) {
        return full_slug.split('/').map(item => item).join('/');
    }


    if ($('.mySwiper').length) {
        const slides = $('.mySwiper .swiper-slide');

        const swiper2 = new Swiper(".mySwiper", {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                800: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                1500: {
                    slidesPerView: 5,
                    spaceBetween: 40
                },
                1700: {
                    slidesPerView: 6,
                    spaceBetween: 40
                }
            }
        });
    } else {
        const swiper = new Swiper(".swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    const sidebar = $("#sidebar");

    $(".burger").click(
        function (e) {
            e.preventDefault();
            sidebar.toggleClass("open");

            if (sidebar.hasClass("open")) {
                $('body').addClass('active');
                sidebar.addClass("active");
            }
        }
    )

    $('.sidebar-toggler').click(function () {
        $("body").toggleClass("active");
        sidebar.toggleClass("active");

        if (!sidebar.hasClass('active') && sidebar.hasClass("open")) {
            sidebar.removeClass("open");
        }
    });

    $(".close-sidebar").click(
        function (e) {
            e.preventDefault();
            if ($("#sidebar").hasClass("open")) {
                $("#sidebar").removeClass("open");
            }
            $("#sidebar").toggleClass("open");
        }
    );

    $('.content-inner').click(function (e) {
        if ($("#sidebar").hasClass('open')) {
            $("#sidebar").removeClass("open");
        }
    });

    $('#sidebar').click(
        function () {
            $("#sidebar").toggleClass("open");
        }
    );

    $(".counter_action").click(
        function (e) {
            let action = $(this).data("action");
            let counter = $(this).parent().children("span").eq(1);
            let counter_value = Number(counter.html());
            if (action == "-") {
                counter_value--;
            } else {
                counter_value++;
            }
            if (counter_value != 0) {
                counter.html(counter_value);
            }
            const data = {};
            const id = counter.data('id');
            data.line = parseInt($(`.${id}-line`).val());
            data.quantity = parseInt(counter_value);
            data.new_type = true;
            $.ajax({
                url: '/zakaz/changeamount/',
                headers: {
                    'X-CSRF-TOKEN': $(`.${id}-csrf`).val()
                },
                data: data,
                type: 'POST',
                success: function (response) {
                    // console.log(response);
                },
                error: function (response) {
                    console.log(response);
                }
            })
            summ();
        }
    )
});

function summ() {
    let global_summ = 0;
    $('.table-content-item').each((index) => {
        const element = $('.table-content-item')[index];
        const id = element.dataset.id;
        if (!id) return 0;
        const element_summ = parseInt($(`.${id}-price`).html());
        const element_amount = parseInt($(`.${id}-amount`).html());
        if (!element_summ || !element_amount) return 0;
        global_summ += (element_summ * element_amount);
    });
    $('#global_summ').html(global_summ);
}


$(".show_more").click(
    function (e) {
        e.preventDefault();
        $(this).parent().toggleClass("showed");
        let action = Number($(this).attr("data-action"));
        let text = action == 0 ? 'Свернуть' : 'Показать больше'
        $(this).children("span").text(text);
        action = action == 0 ? 1 : 0
        $(this).attr("data-action", action);

    }
)

let transform_default = 100
let transform_y = 0;
let transform_x = 0;

$(".img-scale").click(
    function (e) {
        e.preventDefault();
        let transform = $(this).attr("data-transform");
        if (transform == "+") {
            transform_default += 30
        } else {
            transform_default -= 30
        }
        transform_y = 0
        if (transform_default <= 200 && transform_default >= 100) {
            $(this).parent().parent().parent().children("img").css({
                "transform": `scale(${transform_default}%)`
            });
        }
    }
)

$(".transform-translate-y").click(
    function (e) {
        e.preventDefault();
        let img = $(this).parent().parent().parent().children("img")
        let transform_this = img[0].style.transform;

        let class_ = $(this).hasClass("top")
        if (class_ == true) {
            transform_y += 10;
        } else {
            transform_y -= 10;
        }
        if (transform_y >= -100 && transform_y <= 200) {
            transform_this = transform_this.split(" ")[0]
            img[0].style.transform = `scale(${transform_default}%) translate(${transform_x}%,${transform_y}%)`;
            // img.css({
            // "transform": `${transform_this} translateY(${transform_y}%)`
            // })
        }


    }
)

$(".transform-translate-x").click(
    function (e) {
        e.preventDefault();
        let img = $(this).parent().parent().parent().children("img")
        let transform_this = img[0].style.transform;

        let class_ = $(this).hasClass("right")
        if (class_ == true) {
            transform_x -= 10;
        } else {
            transform_x += 10;
        }
        if (transform_x >= -100 && transform_x <= 200) {
            img[0].style.transform = `scale(${transform_default}%) translate(${transform_x}%,${transform_y}%)`;
        }


    }
)

$(window).on("load", function () {
    // $(".guide-page .table-content").mCustomScrollbar();
    // $(".select-1 .select__values").mCustomScrollbar();
    summ();
});


$(".mobile-toggler").click(
    function (e) {
        e.preventDefault();
        $(this).parent().children(".attr").toggle()
        $(this).parent().children(".btn").toggle()
    }
)


$(".select span").click(
    function (e) {
        //$(this).parent().toggleClass("active")
    }
)

$('#file').on('change', (e) => {
    if (e.currentTarget.files[0])
        $('#filename').html(e.currentTarget.files[0].name);
    else
        $('#filename').html('Файл не выбран');
});

// $(".tooltip-img").tooltip()
